export function cleanObject (targetObject) {
	// Recursively remove empty objects from deeply nested object
	let obj = targetObject
	for (let key in obj) {
		if (obj[key] && typeof obj[key] === 'object') {
			cleanObject(obj[key])
		} else continue
		if (Object.keys(obj[key]).length === 0) delete obj[key]
	}
	return obj
}

export function flattenObject (obj, prefix = false, targetObject = null) {
	targetObject = targetObject || {}
	// Preserve empty objects and arrays
	if (typeof obj === 'object' && obj !== null && Object.keys(obj).length === 0) {
		targetObject[prefix] = Array.isArray(obj) ? [] : {}
		return targetObject
	}
	prefix = prefix ? prefix + '.' : ''
	for (let i in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, i)) {
			if (typeof obj[i] === 'object' && obj[i] !== null) {
				// Recursion on nested objects
				flattenObject(obj[i], prefix + i, targetObject)
			} else {
				targetObject[prefix + i] = obj[i]
			}
		}
	}
	return targetObject
}

export function pluralize (noun, count, suffix = 's') {
	return `${count} ${noun}${count !== 1 ? suffix : ''}`
}

export function resetObject (targetObject, defaultValue = null) {
	// single level reset object properties to default value
	let obj = targetObject
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			obj[key] = defaultValue
		}
	}
	return obj
}

export function toStoreHashMap (list, resourceName, defaultItem, keyName = 'id') {
	let hashMap = {}
	for (const item of list) {
		const hashKey = item[keyName]
		hashMap[hashKey] = { ...defaultItem, [resourceName]: item }
	}
	return hashMap
}

export function toStoreObject (resource, resourceName, defaultItem, keyName = 'id') {
	return { ...defaultItem, [resourceName]: resource }
}

export default { flattenObject, pluralize, resetObject, cleanObject, toStoreHashMap, toStoreObject }
